<div
  class="layout-wrapper"
  [ngClass]="{
    'layout-menu-collapsed': menuCollapsed
  }"
>
  <app-topbar></app-topbar>
  <div class="layout-sidebar">
    <app-menu></app-menu>
  </div>
  <div class="layout-main-container">
    <div class="layout-main">
      <p-toast #globalToast id="global-toast"></p-toast>

      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
  <app-sidebar></app-sidebar>
  <div *ngIf="!menuCollapsed" class="layout-mask p-component-overlay"></div>
</div>
